import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, of, ReplaySubject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';
import { LoadPlanning } from '../models/loadplanning.interface';
import { Package } from '../models/package.model';
import { ShoppingCartService } from './shoppingcart.service';
import { TerminalsApiService } from './terminals-api.service';

@Injectable({
  providedIn: 'root'
})
export class LoadplanningService {

  private readonly $loading = new ReplaySubject<boolean>(1);
  public readonly loading$ = this.$loading.pipe(distinctUntilChanged(), shareReplay(1));

  public loadPlanning$ = combineLatest([
    this.shoppingCartService.itemsChanged.pipe(
      startWith([]),
      debounceTime(1000)
    ),
    this.terminalsApiService.currentCountryCode$
  ])
    .pipe(
      tap(() => this.$loading.next(true)),
      switchMap(([items, countryCode]) => items.length >= env.minimumCartItemsForLoadPlanning ? this.post(items, countryCode) : of({} as LoadPlanning)),
      shareReplay(1),
      catchError(error => {
        console.error('LoadPlanningService: Exception', error);
        return of({} as LoadPlanning);
      }),
      tap(() => this.$loading.next(false)),
    );

  constructor(
    private http: HttpClient,
    private shoppingCartService: ShoppingCartService,
    private terminalsApiService: TerminalsApiService,
  ) { }

  post(items: Package[], countryCode: string) {
    return this.http.post<LoadPlanning>(`${env.apiPath}/loadplanning/${countryCode}`, items);
    // mock api, use get
    // return this.http.get<LoadPlanning>(`${env.apiPath}/loadplanning/${countryCode}`);
  }

}
